import type { AppDefinition } from '../../types/apps';

export const SettingsAppDefinition: AppDefinition = {
  appId: 'settings',
  name: 'Settings',
  version: '1.0.0',
  description: 'Manage your account, organization, billing, integrations, and preferences.',

  entityTypes: [],
  requiresEntity: false,
  requiresProps: false,

  component: 'settings',

  icon: {
    type: 'phosphor',
    phosphorIcon: 'Gear',
    phosphorWeight: 'duotone',
    color: '#64748b',
    metadata: {
      source: 'app',
      appId: 'settings',
      isAppIcon: true,
    },
  },

  defaultWindowSize: { width: 1040, height: 720 },

  category: 'system',
  isCore: true,
  isSystem: true,
};

export default SettingsAppDefinition;
